var render = function () {
  var _vm$item, _vm$item2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "560",
      "content-class": "rounded-0"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', {
    attrs: {
      "rounded": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "pa-24"
  }, [_c('h5', {
    staticClass: "tit-txt"
  }, [_vm._v(" " + _vm._s(((_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.name) || "-") + " ")]), _c('v-spacer'), _c('v-btn', {
    staticClass: "my-n24 mr-n18",
    attrs: {
      "text": "",
      "fab": "",
      "tile": ""
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', {
    staticClass: "px-24 pb-24 white-space-pre-line"
  }, [_c('p', {
    staticClass: "page-text--sm color-grey"
  }, [_vm._v(" " + _vm._s(((_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.detail) || "-") + " ")])])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }